<template>
  <div class="tools-content">
    <tool-box-category :list="this.feToolsList">
      <template v-slot:title>Frontend</template>
    </tool-box-category>
    <tool-box-category :list="this.beToolsList">
      <template v-slot:title>Backend</template>
    </tool-box-category>
    <tool-box-category :list="this.devToolsList">
      <template v-slot:title>Herramientas</template>
    </tool-box-category>
  </div>
</template>

<script>
import ToolBoxCategory from "./ToolBoxCategory.vue";

export default {
  components: { ToolBoxCategory },
  props: {
    tools: {
      type: Array,
      required: true,
    },
  },
  computed: {
    feToolsList() {
      return this.tools.filter((tool) => tool.category === "fe");
    },
    beToolsList() {
      return this.tools.filter((tool) => tool.category === "be");
    },
    devToolsList() {
      return this.tools.filter((tool) => tool.category === "devTool");
    },
  },
};
</script>

<style>
.tools-content {
  display: grid;
  /* grid-template-columns: repeat(4, 1fr); */
  grid-template-columns: repeat(3, minmax(300px, 1fr));
  gap: 10px;
  justify-items: center;
  align-items: start;
}

/* Media Query */

@media (max-width: 700px) {
  .tools-content {
    grid-template-columns: repeat(1, minmax(100px, 1fr));
    gap: none;
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
}

</style>
